/** The language picker (review 0021, decision 133): each language names itself in every dictionary. */
const names = {
  "language.en": "English",
  "language.tr": "Türkçe",
  "language.ar": "العربية",
} as const;

export const languageEn = { ...names, "language.title": "Language" } as const;
export const languageTr: Record<keyof typeof languageEn, string> = {
  ...names,
  "language.title": "Dil",
};
export const languageAr: Record<keyof typeof languageEn, string> = {
  ...names,
  "language.title": "اللغة",
};
